import {Button, Card, Divider, message} from "antd";
import {ExpIndex} from "@/pages/resume/components/forms/ExpIndex";
import WantedJob from "@/pages/resume/components/sections/WantedJob";
import {SkillIndex} from "@/pages/resume/components/forms/SkillIndex";
import {useState} from "react";

export const CreateCV = ({onSave}) => {
    const [cvData, setCvData] = useState({
        wantedJob: [],
        experiences: [],
        skills: []
    });
    const handleSave = () => {
        onSave(cvData);
        message.success("Đã lưu CV");
    }
    return (
        <div className={"space-y-8"}>
            <Card className={"border rounded-lg w-fit bg-blue-100"}>
                <h3 className={"text-lg font-semibold text-cyan-800"}>Tạo/Cập nhật CV</h3>
                <p className={"text-cyan-800 text-md"}>- Yêu cầu viết tiếng Việt có dấu, không viết chữ in hoa (trừ chữ
                    cái đầu câu)
                </p>
                <p className={"text-cyan-800 text-md"}>- Các CV không đúng quy định, không đạt chất lượng, nội dung
                    không nghiêm túc sẽ bị xóa không cần báo trước.
                </p>
            </Card>
            <Divider className={"my-4"}/>
            <WantedJob onChange={(data => setCvData({...cvData, wantedJob: data}))}/>
            <ExpIndex onChange={(data => setCvData({...cvData, experiences: data}))}/>
            <SkillIndex onChange={(data => setCvData({...cvData, skills: data}))}/>
            <div className={"flex justify-between items-center gap-4 mt-6"}>
                <span className={"text-red-500"}>Những mục có dấu (*) là bắt buộc</span>
                <Button className={"font-bold w-40 h-10"} type={"primary"} onClick={handleSave}>Lưu</Button>
            </div>
        </div>
    )
}